/**
 * @typedef {Object} BookingClientViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - The name of the client
 */

/**
 * @class
 */
export default class BookingClientViewModel {
  /**
   * Create a new BookingClientViewModel.
   * @param {...BookingClientViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
  }
}
